export default __webpack_public_path__ + "static/week_view-8a93f02353273f309e0cf69584a1ce3f.gif";